import type { FlightDirection, FlightOption } from './types';

/** Curated EWR ↔ LIS schedule stub. Times are typical published locals, not live. */
export const FLIGHTS: FlightOption[] = [
  {
    ident: 'TP202',
    airline: 'TAP Air Portugal',
    airlineCode: 'TP',
    direction: 'outbound',
    origin: 'EWR',
    destination: 'LIS',
    departLocal: '22:15',
    arriveLocal: '10:00+1',
    duration: '6h 45m',
    notes: 'Overnight. Terminal B EWR → Terminal 1 LIS.',
  },
  {
    ident: 'UA60',
    airline: 'United',
    airlineCode: 'UA',
    direction: 'outbound',
    origin: 'EWR',
    destination: 'LIS',
    departLocal: '21:30',
    arriveLocal: '09:20+1',
    duration: '6h 50m',
    notes: 'United metal. Typical winter/summer timing.',
  },
  {
    ident: 'TP201',
    airline: 'TAP Air Portugal',
    airlineCode: 'TP',
    direction: 'inbound',
    origin: 'LIS',
    destination: 'EWR',
    departLocal: '16:40',
    arriveLocal: '19:55',
    duration: '8h 15m',
    notes: 'Daylight crossing. Terminal 1 LIS → Terminal B EWR.',
  },
  {
    ident: 'UA61',
    airline: 'United',
    airlineCode: 'UA',
    direction: 'inbound',
    origin: 'LIS',
    destination: 'EWR',
    departLocal: '12:00',
    arriveLocal: '15:15',
    duration: '8h 15m',
  },
];

export const AIRLINES = ['TAP Air Portugal', 'United'] as const;

export function flightsFor(direction: FlightDirection, airline?: string): FlightOption[] {
  return FLIGHTS.filter((f) => f.direction === direction && (!airline || f.airline === airline));
}

export function airlineBookingUrl(flight: FlightOption, date: string): string {
  if (flight.airlineCode === 'UA') {
    const params = new URLSearchParams({
      f: flight.origin,
      t: flight.destination,
      d: date.replace(/-/g, '/'),
      px: '1',
    });
    return `https://www.united.com/en/us/fsr/choose-flights?${params.toString()}`;
  }
  const params = new URLSearchParams({
    origin: flight.origin,
    destination: flight.destination,
    outboundDate: date,
    adults: '1',
  });
  return `https://www.flytap.com/en-us/booking?${params.toString()}`;
}
